export const ROBOT_FIELD_MIN_WIDTH = 350;
export const ROBOT_FIELD_MIN_HEIGHT = 150;
export const MOBILE_TABS_HEIGHT = '72px';
